module.exports = __webpack_public_path__ + "static/media/20201129_202652_151_IMG_1794.b304d1e6.jpg";